import { render, staticRenderFns } from "./MeansOfTelecomCards.vue?vue&type=template&id=2de8fdc7&scoped=true&"
import script from "./MeansOfTelecomCards.vue?vue&type=script&lang=js&"
export * from "./MeansOfTelecomCards.vue?vue&type=script&lang=js&"
import style0 from "./MeansOfTelecomCards.vue?vue&type=style&index=0&id=2de8fdc7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de8fdc7",
  null
  
)

export default component.exports